import { FC, ReactNode } from 'react'
import { Icon, Popover, Text, Link } from '@/ui'
import { TypographyStyles } from '@/styles'
import { insertBetween } from '@/utils/arrayHelpers'

interface Props {
  popup: {
    title?: string
    body: string | FC
    link?: string
    linkText?: string
  }
  labelComponent?: ReactNode
  className?: string
  bordered?: boolean
}

// Parse string bodies with <br/> into separated elements
const parseTooltipBody = (body: string): ReactNode => {
  if (body.includes('<br/>')) {
    return insertBetween<ReactNode>(
      body.split('<br/>'),
      <>
        <br />
        <br />
      </>
    )
  }

  return body
}

export const Tooltip = ({
  popup,
  labelComponent,
  bordered = false,
  className,
}: Props) => {
  return (
    <Popover>
      <Popover.Trigger asChild>
        <span className={`cursor-pointer ${className ?? ''}`}>
          {labelComponent}
        </span>
      </Popover.Trigger>

      <Popover.Content
        className={`w-min-[250px] ${bordered ? 'bg-neutral-0 border-neutral-200' : 'bg-neutral-0 border-none'}`}
        onOpenAutoFocus={(e: Event) => e.preventDefault()}
      >
        {popup.title && (
          <Text variant={TypographyStyles.H3} className="pt-2 mb-4">
            {popup.title}
          </Text>
        )}

        {typeof popup.body === 'string' ? (
          <Text>{parseTooltipBody(popup.body)}</Text>
        ) : (
          <popup.body />
        )}

        {popup.link && (
          <div className="pt-1">
            <Link href={popup.link} newPage>
              <span className="inline-flex items-center gap-1">
                {popup.linkText || 'Learn more'}
                <Icon icon="arrow-right-long" />
              </span>
            </Link>
          </div>
        )}
      </Popover.Content>
    </Popover>
  )
}
